/* Rotazione degli annunci nella barra. Sul telefono ci sono anche le frecce per sfogliarli. */
(function () {
  function init(root) {
    if (root.dataset.apReady === '1') return;
    root.dataset.apReady = '1';
    var voci = root.querySelectorAll('.ap-barra__annuncio');
    if (voci.length < 2) { root.classList.add('ap-barra--uno'); return; }
    var i = 0, timer = null;
    var attesa = parseInt(root.dataset.apDelay, 10) || 5000;
    var fermo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function vai(d) {
      voci[i].setAttribute('data-attivo', 'false');
      i = (i + d + voci.length) % voci.length;
      voci[i].setAttribute('data-attivo', 'true');
    }
    function parti() { if (fermo) return; clearInterval(timer); timer = window.setInterval(function () { vai(1); }, attesa); }
    root.querySelectorAll('[data-ap-barra-vai]').forEach(function (b) {
      b.addEventListener('click', function () { vai(+b.getAttribute('data-ap-barra-vai')); parti(); });
    });
    parti();
  }
  function boot() {
    var tutte = document.querySelectorAll('[data-ap-barra]');
    for (var i = 0; i < tutte.length; i++) init(tutte[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
